import React, { useState } from 'react';
import { FaCircleChevronLeft, FaCircleChevronRight } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import Meltingimg from "../../images/dashboardImgs/melting.png";
import Mouldimg from "../../images/dashboardImgs/moulding.png";
import PrintingImg from "../../images/dashboardImgs/3Dprinting.jpg";
import processImg from "../../images/dashboardImgs/process.jpg";
import "./DashboardComponent.css";

const DashboardComponent = () => {
    const navigate = useNavigate();
    const [items, setItems] = useState([
        {
            id: 1,
            name: 'Process design',
            des: 'The brake-shoe filling and solidification process is an important step in the fabrication of brake components. The procedure begins with the creation of a mould cavity to suit the appropriate form of the brake shoe. Molten metal, usually made of alloys optimised for endurance and friction resistance, is then carefully poured into the mould. As the metal cools and solidifies within the mould, it acquires the precise shape and properties necessary for excellent braking performance. Proper management of cooling rates and alloy composition is required to assure consistency and strength in the final brake shoe product. This technique is critical in guaranteeing the reliability and safety of braking systems in automotive and industrial applications, emphasising its relevance in foundry operations focused on quality and performance',
            workdes: 'Brake-Shoe Design, Energy Management, Machine status and OEE Calculations ',
            img: processImg,
            path: '/process'
        },
        {
            id: 2,
            name: 'pattern Printing ',
            des: 'The printing process plays a pivotal role in creating detailed molds and cores used in casting operations. This advanced technique utilizes 3D printing technology to produce intricate patterns directly from digital designs, reducing lead times and enhancing flexibility in manufacturing. By using materials like sand or resin, printers can build complex geometries with precision, ensuring molds and cores meet exacting specifications. This method not only accelerates prototype development but also optimizes the production of customized or low-volume parts in the foundry, making it an integral part of modern foundry operations striving for efficiency and innovation',
            workdes: '3D Printer, Process Parameters and Temperature',
            img: PrintingImg,
            path: '/printer'
        },
        {
            id: 3,
            name: 'sand Mixing & mould making',
            des: 'The moulding process is a fundamental step where molds are created to shape molten metal into desired forms. This process begins with the preparation of a mixture of sand and binders, which is packed around a pattern to create a mold cavity. The pattern is then removed, leaving behind a precise negative impression of the final product. Moulds can be made using various techniques such as green sand moulding, shell moulding, or investment casting, depending on the complexity and requirements of the part being produced. Proper moulding is essential for ensuring dimensional accuracy and surface finish of cast components, making it a critical aspect of foundry operations.',
            workdes: 'Mixer motor unit, Actuator and Process parameters',
            img: Mouldimg,
            path: '/mould'
        },
        {
            id: 4, name: 'Melting and Pouring',
            des: 'In a mechanical foundry, the melting process is a crucial stage where metal is heated to its melting point in a furnace. This process involves precise control of temperature and composition to achieve desired material properties. Typically, metals such as iron, steel, and aluminum are melted using induction furnaces or electric arc furnaces, depending on the specific requirements of the foundry. Once molten, the metal is carefully poured into molds to create components ranging from intricate machine parts to robust industrial equipment. The efficiency and accuracy of the melting process are paramount in ensuring the quality and consistency of the final products manufactured in the foundry.',
            workdes: 'Melting Units, Process Parameters and Pouring Units',
            img: Meltingimg,
            path: '/melt'
        },
    ]);

    const nextSlide = () => {
        setItems([...items.slice(1), items[0]]);
    };

    const prevSlide = () => {
        setItems([items[items.length - 1], ...items.slice(0, items.length - 1)]);
    };

    const handleSeeMore = (path) => {
        navigate(path);
    };

    return (
        <div className='slider_main'>
            <div className="container_slide">
                <div className="slide">
                    {items.map(item => (
                        <div key={item.id} className="item" style={{ backgroundImage: `url(${item.img})` }}>
                            <div className="content">
                                <div className="name">{item.name}</div>
                                <div className="des">{item.des}</div>
                                <div className='workdes'><p>What you see inside ?</p>{item.workdes}</div>
                                <button className='seeMoreBtn' onClick={() => handleSeeMore(item.path)}>See More</button>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="button">
                    <button className="prev" onClick={prevSlide}><FaCircleChevronLeft size={35} /></button>
                    <button className="next" onClick={nextSlide}><FaCircleChevronRight size={35} /></button>
                </div>
            </div>
        </div>
    );
};

export default DashboardComponent;